import React from 'react';

const ComputerGraph = () => {
    return (
        <svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1783_376)">
                <path
                    d="M10.2719 1.98507C10.8057 1.98507 11.2384 1.5407 11.2384 0.992537C11.2384 0.444374 10.8057 0 10.2719 0C9.73805 0 9.3053 0.444374 9.3053 0.992537C9.3053 1.5407 9.73805 1.98507 10.2719 1.98507Z"
                    fill="#0FC29A"/>
                <path d="M9.11615 15.1719V17.3966" stroke="url(#paint0_linear_1783_376)" strokeWidth="2"
                      strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M5.02478 18.291H13.514" stroke="url(#paint1_linear_1783_376)" strokeWidth="2"
                      strokeLinecap="round" strokeLinejoin="round"/>
                <path
                    d="M18.3096 7.08969V12.18C18.3096 13.2845 17.4383 14.1792 16.3627 14.1792H2.56696C1.53135 14.1792 0.69043 13.3172 0.69043 12.2523V2.91394C0.69043 1.85335 1.52858 0.992676 2.56143 0.992676H7.92451"
                    stroke="url(#paint2_linear_1783_376)" strokeWidth="2" strokeLinecap="round"
                    strokeLinejoin="round"/>
                <path d="M3.69366 9.85577L6.59337 5.19226L11.4262 9.85577L17.7283 1.55957"
                      stroke="url(#paint3_linear_1783_376)" strokeWidth="2" strokeLinecap="round"
                      strokeLinejoin="round"/>
            </g>
            <defs>
                <linearGradient id="paint0_linear_1783_376"
                                gradientUnits="userSpaceOnUse">
                    <stop offset="0.2" stopColor="#03E4B3"/>
                    <stop offset="1" stopColor="#007FF1"/>
                </linearGradient>
                <linearGradient id="paint1_linear_1783_376"
                                gradientUnits="userSpaceOnUse">
                    <stop offset="0.2" stopColor="#03E4B3"/>
                    <stop offset="1" stopColor="#007FF1"/>
                </linearGradient>
                <linearGradient id="paint2_linear_1783_376" x1="2.27401e-05" y1="7.58596" x2="19" y2="7.58596"
                                gradientUnits="userSpaceOnUse">
                    <stop offset="0.2" stopColor="#03E4B3"/>
                    <stop offset="1" stopColor="#007FF1"/>
                </linearGradient>
                <linearGradient id="paint3_linear_1783_376" x1="3.00326" y1="5.70696" x2="18.4187" y2="5.70696"
                                gradientUnits="userSpaceOnUse">
                    <stop offset="0.2" stopColor="#03E4B3"/>
                    <stop offset="1" stopColor="#007FF1"/>
                </linearGradient>
                <clipPath id="clip0_1783_376">
                    <rect width="19" height="19" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default ComputerGraph;
